import { buildProperty } from "@firecms/core";

/**
 * 顧客可以選的貨幣：新台幣與美元，都能寄送到任何可寄送的國家。
 * 日後要新增貨幣，這裡加上代碼，並在 lib/core/shop-currencies.ts 新增貨幣，所有規格與運費區補上金額。
 */
export const CURRENCIES = { TWD: "新台幣", USD: "美元" } as const;

/** 各幣別金額（元）。新台幣與日圓只能是整數；每個貨幣都要填，沒填的貨幣不能購買或寄送。 */
export function currencyMapProperty(name: string, description: string) {
  return buildProperty({
    name,
    description,
    dataType: "map",
    properties: Object.fromEntries(
      Object.entries(CURRENCIES).map(([code, label]) => [
        code,
        {
          name: `${code}（${label}）`,
          dataType: "number",
          validation: { min: 0, integer: code === "TWD" || code === "JPY" },
        },
      ]),
    ),
  });
}
